import React, { useState } from 'react';
import Modal from '../../components/UI/Modal';
import apiClient from '../../utils/apiClient';
import './GenerateReportModal.css';

const convertToMMDDYYYY = (isoString) => {
  if (!isoString) return '';
  const [year, month, day] = isoString.split('-');
  return `${month}/${day}/${year}`;
};

const parseMMDDYYYY = (mmddyyyy) => {
  if (!mmddyyyy) return null;
  const [month, day, year] = mmddyyyy.split('/');
  return new Date(+year, +month - 1, +day);
};

const formatForQuery = (dateObj) => {
  const mm = `${dateObj.getMonth() + 1}`.padStart(2, '0');
  const dd = `${dateObj.getDate()}`.padStart(2, '0');
  const yyyy = dateObj.getFullYear();
  return `${mm}${dd}${yyyy}`;
};

const GenerateReportModal = ({ reportType, onClose }) => {
  const [fromDate, setFromDate] = useState('');
  const [toDate,   setToDate]   = useState('');
  const [error,    setError]    = useState('');

  const handleFromDateChange = e => setFromDate(convertToMMDDYYYY(e.target.value));
  const handleToDateChange   = e => setToDate(convertToMMDDYYYY(e.target.value));

  const handleGenerate = async () => {
    console.log('Generating:', reportType, fromDate, toDate);
    setError('');

    if (!fromDate || !toDate) {
      setError('Please select both start and end dates.');
      return;
    }

    const start = parseMMDDYYYY(fromDate);
    const end   = parseMMDDYYYY(toDate);
    const now   = new Date();
    if (!start || !end || isNaN(start) || isNaN(end)) {
      setError('Invalid dates.');
      return;
    }
    if (start > end) {
      setError('Start date must be before end date.');
      return;
    }
    if (start > now || end > now) {
      setError('Dates cannot be in the future.');
      return;
    }

    let endpoint, filename;
    if (reportType === 'Device Report') {
      endpoint = '/export_devices';
      filename = 'devices.csv';
    } else if (reportType === 'User Report') {
      endpoint = '/export_users';
      filename = 'users.csv';
    } else if (reportType === 'User Mapping Report') {
      endpoint = '/export_user_devices';
      filename = 'user_devices.csv';
    } else if (reportType === 'User Activity Report') {
      endpoint = '/export_user_activity';
      filename = 'user_activity.csv';
    } else {
      setError(`"${reportType}" not implemented yet.`);
      return;
    }

    const params = {
      start_date:   formatForQuery(start),
      end_date: formatForQuery(end),
    };

    try {
      const response = await apiClient.get(endpoint, {
        params,
        responseType: 'blob',
      });
      const blob = new Blob([response.data], { type: 'text/csv' });
      const url  = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      onClose();
    } catch (err) {
      console.error('Export failed:', err);
      setError('Failed to export. Please try again.');
    }
  };

  return (
    <Modal>
      <div className="generate-report-modal">
        <h2>{reportType}</h2>

        <label className="generate-report-label">Select Date Range</label>
        {error && <p className="error-message">{error}</p>}

        <div className="generate-report-date-group">
          <input
            type="date"
            onChange={handleFromDateChange}
            className="generate-report-input"
          />
          <input
            type="date"
            onChange={handleToDateChange}
            className="generate-report-input"
          />
        </div>

        <div className="generate-report-actions">
          <button
            type="button"
            className="generate-report-button cancel"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="generate-report-button generate"
            onClick={handleGenerate}
          >
            Generate
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default GenerateReportModal;
